import moment from "moment";
import uuid from '../../plugins/uuid'

export default {
  namespaced: true,
  state: {
    toasts: []
  },
  actions: {
    purge: ({ commit }) => {
      commit('PURGE_TOAST')
    },
    drop: ({ commit }, index) => {
      commit('DROP_TOAST', index)
    },
    extend: ({ commit }, index) => {
      commit('EXTEND_TOAST', index)
    },
    add: ({ commit }, data) => {
      commit('PURGE_TOAST')
      commit('ADD_TOAST', data)
    },
  },
  mutations:{
    ADD_TOAST: (state, data) => {
      let now = new Date();
      let exp = moment(now).add(5, 's').toDate().getTime();
      let array = state.toasts
      array.push({ id: uuid.v4(),type: data.type, message: data.message, exp: exp })
      state.toasts = array
    },
    PURGE_TOAST: (state) => {
      let now = new Date();
      state.toasts.forEach(function (element, index) {
        if(element !== null && element.exp <= now.getTime()){
          state.toasts.splice(index, 1)
        }
      })
    },
    EXTEND_TOAST: (state, index) => {
      if(!state.toasts[index]) return
      let now = new Date();
      state.toasts[index].exp = moment(now).add(5, 's').toDate().getTime();
    },
    DROP_TOAST: (state, index) => {
      if(!state.toasts[index]) return
      state.toasts.splice(index, 1)
    }
  },
  getters: {
    toasts: (state) => state.toasts
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/toast.js